import Link from "next/link";
import { RoutineBackArrowIcon } from "@/components/icons/RoutineBackArrowIcon";

const BackButton = ({
  title,
  slug,
  wrapperCl = "",
}: {
  title: string;
  slug: string;
  wrapperCl?: string;
}) => {
  return (
    <div className={`${wrapperCl} flex items-center`}>
      <Link
        href={slug}
        className="inline-flex items-center gap-2 text-3.5 text-fg-subtle bg-none border-none py-1.5 px-2.5 -ml-2.5 rounded-8 cursor-pointer transition-colors hover:text-fg-default hover:bg-bg-subtle [&_svg]:w-3.5 [&_svg]:h-3.5 [&_svg]:[stroke:currentColor]"
      >
        <RoutineBackArrowIcon /> {title}
      </Link>
    </div>
  );
};

export default BackButton;
